/**
 * A determinate upload progress bar for the design-upload dialogs. Represents the S3 byte
 * transfer only (0‥100%); once it reaches 100% the design row hands off to the async
 * "Validating…" state. Accessible: role=progressbar with aria-valuenow, reduced-motion safe.
 */

/** Clamp a 0‥1 fraction to an integer percentage (non-finite → 0). Exported for a DOM-free test. */
export function uploadPct(fraction: number): number {
  if (!Number.isFinite(fraction)) return 0;
  return Math.round(Math.max(0, Math.min(1, fraction)) * 100);
}

export function UploadProgress({ label, fraction }: { label: string; fraction: number }) {
  const pct = uploadPct(fraction);
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{label}</span>
        <span className="tabular-nums">{pct}%</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
        <div
          role="progressbar"
          aria-label={label}
          aria-valuenow={pct}
          aria-valuemin={0}
          aria-valuemax={100}
          className="h-full rounded-full bg-primary transition-[width] duration-200 ease-out motion-reduce:transition-none"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
